/* HeadingWithTabs.tsx generated by @compiled/babel-plugin v0.36.0 */
import { ax, ix, CC, CS } from "@compiled/react/runtime";
import { media } from '@atlaskit/primitives';
import { BodyNormal, H3 } from '@atlassian/mpac-primitives';
import { jsxs as _jsxs, jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
const _25 = "._irr3i1yw:hover{background-color:var(--ds-background-selected-hovered,#cce0ff)}";
const _24 = "._bfhkfg4m{background-color:var(--ds-background-selected,#e9f2ff)}";
const _23 = "._1a37nmxp{outline:var(--_nu2mv8)}";
const _22 = "._1ubtnmxp:hover{outline:var(--_nu2mv8)}";
const _21 = "._80omtlke{cursor:pointer}";
const _20 = "._syaz1fxt{color:var(--ds-text,#172b4d)}";
const _19 = "._bfhkm7j4{background-color:var(--ds-background-neutral,#091e420f)}";
const _18 = "._1wyb1j6v{font-size:1rem}";
const _17 = "._2rko53f4{border-radius:75pt}";
const _16 = "._19itidpf{border:0}";
const _15 = "._1yt41qz8{padding:var(--_1ha3kwm)}";
const _14 = "@media not all and (min-width:48rem){._15txv77o{padding:var(--ds-space-025,2px)}._1o831wug{overflow-x:auto}._1jk9glyw{scrollbar-width:none}._3nz5glyw{ms-overflow-style:none}._1ggmxy5q{padding-right:var(--ds-space-400,2pc)}._nssp1y6m{justify-content:flex-start}._navj1q9c{flex-wrap:nowrap}._z61jglyw::-webkit-scrollbar{display:none}._1hxvidpf>button{flex-shrink:0}}";
const _13 = "._1n261g80{flex-wrap:wrap}";
const _12 = "._1bah1h6o{justify-content:center}";
const _11 = "._1e0c1txw{display:flex}";
const _10 = "._zulppxbi{gap:var(--ds-space-200,1pc)}";
const _9 = "._p12fiafe{max-width:60.5rem}";
const _8 = "._syaz1gjq{color:var(--ds-text-subtle,#44546f)}";
const _7 = "._18u01wug{margin-left:auto}";
const _6 = "._otyridpf{margin-bottom:0}";
const _5 = "._2hwx1wug{margin-right:auto}";
const _4 = "._19pkidpf{margin-top:0}";
const _3 = "._otyru2gc{margin-bottom:var(--ds-space-100,8px)}";
const _2 = "._otyrxy5q{margin-bottom:var(--ds-space-400,2pc)}";
const _ = "._y3gn1h6o{text-align:center}";
const headerSection = null;
const headingStyles = null;
const descriptionStyles = null;
const tabButtonContainer = null;
const tabButton = null;
const activeTabButton = null;
export const HeadingWithTabs = _ref => {
  let {
    title,
    description,
    tabItems,
    activeTabId,
    onTabChange
  } = _ref;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(CC, {
      children: [/*#__PURE__*/_jsx(CS, {
        children: [_, _2]
      }), /*#__PURE__*/_jsxs("div", {
        className: ax(["_y3gn1h6o _otyrxy5q"]),
        children: [/*#__PURE__*/_jsxs(CC, {
          children: [/*#__PURE__*/_jsx(CS, {
            children: [_3]
          }), /*#__PURE__*/_jsx(H3, {
            as: "h2",
            className: ax(["_otyru2gc"]),
            children: title
          })]
        }), description && /*#__PURE__*/_jsxs(CC, {
          children: [/*#__PURE__*/_jsx(CS, {
            children: [_4, _5, _6, _7, _8, _9]
          }), /*#__PURE__*/_jsx(BodyNormal, {
            className: ax(["_19pkidpf _2hwx1wug _otyridpf _18u01wug _syaz1gjq _p12fiafe"]),
            children: description
          })]
        })]
      })]
    }), /*#__PURE__*/_jsxs(CC, {
      children: [/*#__PURE__*/_jsx(CS, {
        children: [_10, _11, _12, _13, _14]
      }), /*#__PURE__*/_jsx("div", {
        className: ax(["_zulppxbi _1e0c1txw _1bah1h6o _1n261g80 _15txv77o _1o831wug _1jk9glyw _3nz5glyw _1ggmxy5q _nssp1y6m _navj1q9c _z61jglyw _1hxvidpf"]),
        children: tabItems.map(item => /*#__PURE__*/_jsxs(CC, {
          children: [/*#__PURE__*/_jsx(CS, {
            children: [_15, _16, _17, _18, _19, _20, _21, _22, _23, _24, _25]
          }), /*#__PURE__*/_jsx("button", {
            role: "tab",
            "aria-label": item.tabAriaLabel,
            onClick: () => onTabChange(item.id),
            type: "button",
            className: ax(["_1yt41qz8 _19itidpf _2rko53f4 _1wyb1j6v _bfhkm7j4 _syaz1fxt _80omtlke _1ubtnmxp", activeTabId === item.id && "_1a37nmxp _bfhkfg4m _irr3i1yw"]),
            style: {
              "--_1ha3kwm": ix("var(--ds-space-200, 16px)".concat(" 1.75rem")),
              "--_nu2mv8": ix("2px solid ".concat("var(--ds-border-selected, #0C66E4)"))
            },
            children: item.label
          }, item.id)]
        }, item.id))
      })]
    })]
  });
};